/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Starter_Challenge_Phase_4_TitleInputs */

const en_starter_challenge_phase_4_title = /** @type {(inputs: Starter_Challenge_Phase_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your Reward Awaits`)
};

const ar_starter_challenge_phase_4_title = /** @type {(inputs: Starter_Challenge_Phase_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مكافأتك بانتظارك`)
};

const de_starter_challenge_phase_4_title = /** @type {(inputs: Starter_Challenge_Phase_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ihre Belohnung erwartet Sie`)
};

const es_starter_challenge_phase_4_title = /** @type {(inputs: Starter_Challenge_Phase_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu recompensa te espera`)
};

const fr_starter_challenge_phase_4_title = /** @type {(inputs: Starter_Challenge_Phase_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Votre récompense vous attend`)
};

const it_starter_challenge_phase_4_title = /** @type {(inputs: Starter_Challenge_Phase_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La tua ricompensa ti aspetta`)
};

const ja_starter_challenge_phase_4_title = /** @type {(inputs: Starter_Challenge_Phase_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`報酬を獲得！`)
};

const ko_starter_challenge_phase_4_title = /** @type {(inputs: Starter_Challenge_Phase_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`리워드 도착!`)
};

const pt_br_starter_challenge_phase_4_title = /** @type {(inputs: Starter_Challenge_Phase_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sua recompensa te espera`)
};

const ru_starter_challenge_phase_4_title = /** @type {(inputs: Starter_Challenge_Phase_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вас ждет награда`)
};

const th_starter_challenge_phase_4_title = /** @type {(inputs: Starter_Challenge_Phase_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รางวัลของคุณกำลังรออยู่`)
};

const tr_starter_challenge_phase_4_title = /** @type {(inputs: Starter_Challenge_Phase_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ödülün Seni Bekliyor`)
};

const zh_cn_starter_challenge_phase_4_title = /** @type {(inputs: Starter_Challenge_Phase_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你的奖励正等着你！`)
};

const zh_tw_starter_challenge_phase_4_title = /** @type {(inputs: Starter_Challenge_Phase_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你的獎勵正等著你！`)
};

/**
* | output |
* | --- |
* | "Your Reward Awaits" |
*
* @param {Starter_Challenge_Phase_4_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const starter_challenge_phase_4_title = /** @type {((inputs?: Starter_Challenge_Phase_4_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Starter_Challenge_Phase_4_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_starter_challenge_phase_4_title(inputs)
	if (locale === "ar") return ar_starter_challenge_phase_4_title(inputs)
	if (locale === "de") return de_starter_challenge_phase_4_title(inputs)
	if (locale === "es") return es_starter_challenge_phase_4_title(inputs)
	if (locale === "fr") return fr_starter_challenge_phase_4_title(inputs)
	if (locale === "it") return it_starter_challenge_phase_4_title(inputs)
	if (locale === "ja") return ja_starter_challenge_phase_4_title(inputs)
	if (locale === "ko") return ko_starter_challenge_phase_4_title(inputs)
	if (locale === "pt_br") return pt_br_starter_challenge_phase_4_title(inputs)
	if (locale === "ru") return ru_starter_challenge_phase_4_title(inputs)
	if (locale === "th") return th_starter_challenge_phase_4_title(inputs)
	if (locale === "tr") return tr_starter_challenge_phase_4_title(inputs)
	if (locale === "zh_cn") return zh_cn_starter_challenge_phase_4_title(inputs)
	return zh_tw_starter_challenge_phase_4_title(inputs)
});